













































































































































import { Mixins, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';
import { TempEmployee, UserRegisterPageInfo } from '@/interfaces';

type Group = I.AxZone;

type PageInfo = I.MealSettingPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<I.PacketTempGeneralIssue, State>;
type DataStore = U.DataStore<I.PacketTempGeneralIssue>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  listCompanyCode: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  constructor() {
    this.listCompanyCode = [];
    this.listDeptCodeB = [];
  }
}

class DialogState<T extends I.CodeData> {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: T[];
  headers: unknown[];
  items: T[];
  singleSelect: boolean;
  zoneCode: number;
  callback: Function;

  onAdd(list: T[]) {
    list.forEach(item => {
      this.selected.push(item);
    });
  }

  onRemove(list: T[]) {
    list.forEach(item => {
      const find = this.selected.find(x => x.code === item.code);
      if (find) {
        const idx = this.selected.indexOf(find);
        if (idx > -1) {
          this.selected.splice(idx, 1);
        }
      }
    });
  }

  constructor() {
    this.singleSelect = true;
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.zoneCode = 0;
    this.callback = async () => {};
  }
}

enum ECodeType {
  ECompanyCode,
  EDeptCodeA,
  EDeptCodeB,
  EDutyCodeA
}

class CodeDialogState {
  show: boolean;
  title: string;
  items: I.CodeData[];
  selected: unknown;
  search: string;
  headers: unknown[];
  codeType: ECodeType;
  callback: Function;

  constructor() {
    this.show = false;
    this.title = '';
    this.items = [];
    this.search = '';
    this.headers = [];
    this.callback = async () => {};
    this.codeType = ECodeType.ECompanyCode;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  dataItem!: DataItem;
  state = new State();

  pageInfo?: UserRegisterPageInfo;
  listUserStatus: I.CodeData[] = [];
  listUserType: I.CodeData[] = [];
  dialogState = new DialogState();
  codeDialogState = new CodeDialogState();
  message = '';
  tabCard = 0;
  tabZone = 0;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  callback!: Function;

  async getPageInfo() {
    const result = await this.API.call.user.getRegisterPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class DialogHandler extends BaseClass {
  openCodeSelectDialog(title: string, name: string) {
    console.log('pageinfo', this.pageInfo);
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.pageInfo as unknown) as { [name: string]: I.CodeData[] })[name];
    console.log('items', items);
    const selected = ((this.state as unknown) as {
      [name: string]: I.CodeData[];
    })[name];
    console.log('selected', selected);
    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      ((this.state as unknown) as { [name: string]: I.CodeData[] })[name] = selected.sort((a, b) =>
        a.code.localeCompare(b.code)
      );
    };
    console.log('callback', callback);
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    console.log('open dialog');
    console.log(callback);
    this.dialogState.show = true;
    this.dialogState.singleSelect = false;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    if (this.dialogState.singleSelect) {
      this.dialogState.selected = [];
      this.dialogState.selected.push(item);
    } else {
      const idx = this.dialogState.selected.findIndex(x => x === item);
      if (idx > -1) {
        this.dialogState.selected.splice(idx, 1);
      } else {
        this.dialogState.selected.push(item);
      }
    }
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 550;
  height = 630;

  state = new State();
  pageInfo?: UserRegisterPageInfo;
  listUserStatus: I.CodeData[] = [];
  listUserType: I.CodeData[] = [];
  dialogState = new DialogState();
  codeDialogState = new CodeDialogState();
  message = '';
  tabCard = 0;
  tabZone = 0;

  @Prop({ type: Function, default: () => {} })
  callback!: Function;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  onAdd(list: I.CodeData[]) {
    this.dialogState.onAdd(list);
  }

  onRemove(list: I.CodeData[]) {
    this.dialogState.onRemove(list);
  }

  onDialogRowClicked(item: never) {
    this.codeDialogState.selected = item;
  }

  async getBaseData() {
    const result = await this.API.call.user.getRegisterPageInfo();
    console.log('prepare', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async closeDialog() {
    console.log('close dialog');
    this.codeDialogState.show = false;
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
      this.codeDialogState = new CodeDialogState();
      if (this.pageInfo) {
        // this.pageInfo.listDoor.forEach(item => {
        //   this.dialogState.items.push({
        //     code: item.code,
        //     name: item.name,
        //     zoneCode: item.zoneCode,
        //     zoneName: item.zoneName
        //   });
        // });
      }
    }, 100);
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler, DialogHandler));

@Component
export default class AxAccountFilterDialog extends Mixins(BaseData, Handlers) {
  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  async prepare() {
    console.log('prepare', this.param);
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
    }

    if (this.param) {
      this.state.listCompanyCode = this.param.items[0].companycodeFilterList;
      this.state.listDeptCodeB = this.param.items[0].deptcodebFilterList;
    }
    console.log('start', this.param);
  }

  onDialogSelected() {
    if (this.state.listCompanyCode.length > 0) {
      this.param.selected[0].companycodeFilterList = this.state.listCompanyCode;
    }
    if (this.state.listDeptCodeB.length > 0) {
      this.param.selected[0].deptcodebFilterList = this.state.listDeptCodeB;
    }
    this.param.callback();
    this.$emit('changed', this.on);
  }
}
